import { QuestionTypeToClassMap } from './QuestionTypeToClassMap'
import { IQuestion } from 'app/interfaces/IQuestion'
import { QuestionFactoryValidationError } from 'app/custom-errors/QuestionFactoryValidationError'
import { normalizeInfoMatrixQuestion } from 'app/models/questions/normalize-info-matrix-question'
import { normalizeQuestionValidatorFields } from 'app/models/questions/normalize-question-validator-fields'

type QuestionMap = typeof QuestionTypeToClassMap;
type Tuples<T> = T extends QuestionType ? [T, InstanceType<QuestionMap[T]>] : never;
type ClassType<A extends QuestionType> = Extract<Tuples<QuestionType>, [A, any]>[1];
type QuestionType = keyof QuestionMap;

export class QuestionFactory {
  static buildQuestionClass<K extends QuestionType>(question: IQuestion): ClassType<K> {
    this.validateQuestionType(question)
    normalizeQuestionValidatorFields(question)
    normalizeInfoMatrixQuestion(question)
    return new QuestionTypeToClassMap[question.viewerType](question)
  }

  private static validateQuestionType(question: IQuestion) {
    if (!QuestionTypeToClassMap[question.viewerType]) {
      throw new QuestionFactoryValidationError(question.viewerType, question.key)
    }
  }
}
